import React, { ReactElement } from 'react';
type Props = {
  children: ReactElement<any>;
  condition: boolean;
};
const ConditionalRenderer = ({
  children,
  condition
}: Props) => condition ? children : null;
export default ConditionalRenderer;